import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';
import { RequestApiResult } from 'loopback-react-request';

import '../ChangePassword.page.scss';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ChangePasswordSucceeded.messages';
import { Link } from 'react-router-dom';

export interface ChangePasswordSucceededPageProps {
  dispatch: any;
  changePassword: RequestApiResult<any>;
}

export class ChangePasswordSucceededPageComponent extends React.Component<ChangePasswordSucceededPageProps> {

  public render() {
    return (
      <div className="page-changepassword d-flex justify-content-center align-items-center h-100">
        <div className="inner pt-5 pb-5">
          <LogoCentered />
          <div className="col-12">
            <h4>
              <FormattedMessage {...MESSAGES.passwordChangedHeading} />
            </h4>
            <p>
              <FormattedMessage {...MESSAGES.passwordChangedText} />
            </p>
            <Link className="btn btn-secondary d-block" to="/">
              <FormattedMessage {...MESSAGES.passwordChangedButton} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

interface StateProps {
  changePassword: RequestApiResult<any>;
} 

export const ChangePasswordSucceededPage = connect((state: StateProps) => ({
  changePassword: state.changePassword,
}))( ChangePasswordSucceededPageComponent);

export default ChangePasswordSucceededPage;